// @flow

// zeserializuje object key/value do stringu použitelného jako parametry v url
export const serializeToParamsString = (obj: Object): string =>
  Object.keys(obj).map((key) => {
    const value = obj[key];
    if (Array.isArray(value)) {
      return value.map((subValue) => `${encodeURIComponent(key)}=${encodeURIComponent(subValue)}`).join('&');
    }
    return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  }).join('&');

/*
seřadí klíče v objectu podle názvu vzestupně
*/
export const sortObject = (o: Object): Object =>
  Object.keys(o)
    .sort()
    .reduce((r, k) => {
      r[k] = o[k];
      return r;
    }, {});

export const getObjectByName = (name: string, obj: Object): ?any => {
  const parts = name.split('.');
  let cur = obj;
  // eslint-disable-next-line
  for (let part; part = parts.shift();) {
    if (cur[part] != null) {
      cur = cur[part];
    } else {
      return null;
    }
  }
  return cur;
};

/**
 * Returns true if the specified value is an object.  This includes arrays and
 * functions.
 */
export const isObject = (val: ?any): boolean => {
  const type = typeof val;
  return type === 'object' && (
    val != null || type === 'function'
  );
  // return Object(val) === val also works, but is slower, especially if val is
  // not an object.
};





// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/lib/object.js